import Swal from 'sweetalert2'
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Inject } from '@angular/core';
export class _Message {
  
    static confir_actualizar:string = "¿Está seguro de actualizar?";
    static confir_guardar:string = "¿Está seguro de guardar?";

    static emailRegex = new RegExp(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+)+([;]([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+))*$/);
    static ipRegex = new RegExp(/^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/);

    static msjLetras:string = "Solo puede ingresar letras."
    static msjEmail:string = "Ingrese un email valido."
    

    public static getMessageForm(   campo:String,
                                    required:Boolean,
                                    minlength:number,
                                    maxlength:number,
                                    message_pattern:String,
                                    ruc:Boolean){
        var ListMessage = [];
        if(required)
            ListMessage.push({ type: 'required', message: '\"'+campo+'\" es requerido' });
        if(minlength > 0)
            ListMessage.push({ type: 'minlength', message: '\"'+campo+'\" debe tener al menos '+minlength+' caracteres' })
        if(maxlength > 0)
            ListMessage.push({ type: 'maxlength', message: '\"'+campo+'\" no puede tener más de '+ maxlength+' caracteres' },)
        if(message_pattern != undefined && message_pattern != "" && message_pattern != null)
            ListMessage.push({ type: 'pattern', message: message_pattern })
        if(ruc)
            ListMessage.push({ type: 'cedulaRuc', message: "Cedula o Ruc invalido" })
      
        return ListMessage;
    }

  public static parametro(part) {
    debugger;
    let storage: WebStorageService;
    var part =storage.get("PARAMETROCLAVE");
    
  }


  public static getToast() {
    return Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      onOpen: (toast) => {
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    });
  }
 

  

 }
